import { render, staticRenderFns } from "./YoutubeUsers.vue?vue&type=template&id=2912ef80"
import script from "./YoutubeUsers.vue?vue&type=script&lang=js"
export * from "./YoutubeUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports